import { 
  LayoutDashboard, 
  GraduationCap, 
  UserRoundCheck, 
  BookOpen, 
  CalendarCheck, 
  ClipboardCheck, 
  Wallet, 
  CreditCard, 
  Library, 
  Bus, 
  Building2, 
  BarChart3, 
  Settings,
  HardDrive,
  Award,
  MessageSquare
} from 'lucide-react';

export const getSidebarNavSections = () => {
  // Academics submenu for School ERP
  const academicChildren = [
    { id: 'classes', label: 'Classes', activeTab: 'academics', subTab: 'classes' },
    { id: 'subjects', label: 'Subjects', activeTab: 'academics', subTab: 'subjects' },
    { id: 'timetable', label: 'Time Table', activeTab: 'academics', subTab: 'timetable' },
    { id: 'assignments', label: 'Homework', activeTab: 'academics', subTab: 'assignments' },
    { id: 'ptm', label: 'PTM Meetings', activeTab: 'academics', subTab: 'ptm' }
  ];

  return [
    {
      id: 'main',
      title: null,
      items: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          icon: LayoutDashboard,
          activeTab: 'dashboard'
        }
      ]
    },
    {
      id: 'student_management',
      title: 'STUDENT MANAGEMENT',
      items: [
        {
          id: 'students',
          label: 'Students',
          icon: GraduationCap,
          activeTab: 'students',
          permission: 'students.view',
          children: [
            { id: 'student-list', label: 'Student List', activeTab: 'students', actionType: 'student_list' },
            { id: 'add-student', label: 'Add Student', activeTab: 'students', actionType: 'add_student' },
            { id: 'bulk-import', label: 'Bulk Import', activeTab: 'students', actionType: 'bulk_add' }
          ]
        }
      ]
    },
    {
      id: 'staff_management',
      title: 'STAFF MANAGEMENT',
      items: [
        {
          id: 'teachers',
          label: 'Teachers',
          icon: UserRoundCheck,
          activeTab: 'teachers',
          permission: 'teachers.view'
        }
      ]
    },
    {
      id: 'academics_section',
      title: 'ACADEMICS',
      items: [
        {
          id: 'academics',
          label: 'Academics',
          icon: BookOpen,
          activeTab: 'academics',
          permission: 'academics.view',
          children: academicChildren
        },
        {
          id: 'attendance',
          label: 'Attendance',
          icon: CalendarCheck,
          activeTab: 'attendance',
          permission: 'attendance.view',
          children: [
            { id: 'smart-attendance-studio', label: '✨ Smart Attendance Studio', activeTab: 'smart_attendance', subTab: 'studio' },
            { id: 'student-attendance', label: 'Student Attendance', activeTab: 'attendance', subTab: 'student' },
            { id: 'teacher-attendance', label: 'Teacher Attendance', activeTab: 'attendance', subTab: 'teacher_attendance' },
            { id: 'attendance-reports', label: 'Attendance Reports', activeTab: 'attendance', subTab: 'summary' }
          ]
        },
        {
          id: 'marks-cards',
          label: 'Examinations',
          icon: ClipboardCheck,
          activeTab: 'marks-cards',
          permission: 'examinations.view'
        }
      ]
    },
    {
      id: 'finance_section',
      title: 'FINANCE',
      items: [
        {
          id: 'fees',
          label: 'Fees',
          icon: Wallet,
          activeTab: 'fees',
          permission: 'fees.view',
          children: [
            { id: 'manage-fees', label: 'Fee Management', activeTab: 'fees', subTab: 'management' },
            { id: 'fee-collection', label: 'Fee Collection', activeTab: 'fees', subTab: 'collection' },
            { id: 'payment-verifications', label: 'Payment Verifications', activeTab: 'fees', subTab: 'verifications' },
            { id: 'fee-reports', label: 'Fee Reports', activeTab: 'fees', subTab: 'reports' },
            { id: 'fee-structures', label: 'Fee Structures', activeTab: 'fees', subTab: 'structures' }
          ]
        }
      ]
    },
    {
      id: 'communication_section',
      title: 'COMMUNICATION',
      items: [
        {
          id: 'communication',
          label: 'Communication Hub',
          icon: MessageSquare,
          activeTab: 'communication',
          permission: 'communication.view',
          children: [
            { id: 'broadcast-message', label: '📢 Send & Broadcast', activeTab: 'communication', subTab: 'compose' },
            { id: 'message-templates', label: '📝 Message Templates', activeTab: 'communication', subTab: 'templates' },
            { id: 'automation-rules', label: '⚙️ Automation Rules', activeTab: 'communication', subTab: 'rules' },
            { id: 'whatsapp-gateway', label: '📱 WhatsApp Gateway', activeTab: 'communication', subTab: 'gateway' },
            { id: 'delivery-history', label: '📜 Delivery Reports', activeTab: 'communication', subTab: 'history' }
          ]
        }
      ]
    },
    {
      id: 'services_section',
      title: 'SCHOOL SERVICES',
      items: [
        {
          id: 'id-cards',
          label: 'ID Cards',
          icon: CreditCard,
          activeTab: 'id-cards',
          permission: 'idcards.view'
        },
        {
          id: 'certificates',
          label: 'Certificates & TC',
          icon: Award,
          activeTab: 'certificates',
          permission: 'certificates.view'
        },
        {
          id: 'library',
          label: 'Library',
          icon: Library,
          activeTab: 'library',
          permission: 'library.view'
        },
        {
          id: 'vehicle',
          label: 'Transport',
          icon: Bus,
          activeTab: 'vehicle',
          permission: 'transport.view'
        },
        {
          id: 'hostel',
          label: 'Hostel',
          icon: Building2,
          activeTab: 'hostel',
          permission: 'hostel.view'
        }
      ]
    },
    {
      id: 'analytics_section',
      title: 'ANALYTICS',
      items: [
        {
          id: 'reports',
          label: 'Reports',
          icon: BarChart3,
          activeTab: 'reports',
          permission: 'reports.view',
          children: [
            { id: 'general-analytics', label: 'General Analytics', activeTab: 'reports', subTab: 'analytics' },
            { id: 'admission-register', label: 'Admission Reports', activeTab: 'reports', subTab: 'admission_register' },
            { id: 'master-list', label: 'Student Master List', activeTab: 'reports', subTab: 'master_list' }
          ]
        }
      ]
    },
    {
      id: 'system_section',
      title: 'SYSTEM',
      items: [
        {
          id: 'storage',
          label: 'Media Storage',
          icon: HardDrive,
          activeTab: 'storage',
          permission: 'storage.view'
        },
        {
          id: 'settings',
          label: 'Settings',
          icon: Settings,
          activeTab: 'settings',
          permission: 'settings.view'
        }
      ]
    }
  ];
};

export const SIDEBAR_NAV_SECTIONS = getSidebarNavSections('SCHOOL');
